export { default as CarouselSlides } from './CarouselSlides'
export type { CarouselSlidesProps } from './types'
